import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { formatPrice } from '@spotahome/soyuz-currency';

import ListRow from '@spotahome/marketplace-common/src/components/ListRow';

import ListingTitle from '../ListingTitle';

import './ServicesAndExpenses.scss';

const DEFAULT_PERIODIC_CLEANING_VALUE = 'tenantResponsibility';
const DONT_KNOW_VALUE = 'dontKnow';
const ONE_TIME_FREQUENCIES = ['onlyAtMoveIn', 'onlyAtMoveOut'];

const getAvailabilityTranslation = ({
  additionalInfo,
  currencyLabel,
  value
}) => {
  const isOneTimeFrequency = ONE_TIME_FREQUENCIES.includes(
    additionalInfo?.frequency
  );

  const transKey =
    isOneTimeFrequency && value === 'availableForAdditionalFee'
      ? `listing.services.cleaning.availability.availableForAdditionalFeeOneTime`
      : `listing.services.cleaning.availability.${value}`;

  const transOptions = additionalInfo?.fee
    ? {
        fee: formatPrice(additionalInfo.fee / 100, currencyLabel)
      }
    : {};

  return trans(transKey, transOptions);
};

const ServicesAndExpenses = ({ currencyLabel, periodicCleaning = {} }) => {
  const { additionalInfo, value = DEFAULT_PERIODIC_CLEANING_VALUE } =
    periodicCleaning;

  return (
    <Fragment>
      <ListingTitle role="tertiary">
        {trans('listing.pricing.title.services')}
      </ListingTitle>
      <ListRow
        renderLeftBlock={() => (
          <p>{trans('listing.pricing.cleaning-service')}</p>
        )}
        renderRightBlock={() => (
          <div className="services-expenses-item__value-wrapper">
            <b className="services-expenses-item__value">
              {getAvailabilityTranslation({
                additionalInfo,
                currencyLabel,
                value:
                  value === DONT_KNOW_VALUE
                    ? DEFAULT_PERIODIC_CLEANING_VALUE
                    : value
              })}
            </b>

            {additionalInfo?.frequency && (
              <span className="services-expenses-item__value-subtitle">
                {trans(
                  `listing.services.cleaning.frequency.${additionalInfo.frequency}`
                )}
              </span>
            )}
          </div>
        )}
      />
    </Fragment>
  );
};

ServicesAndExpenses.propTypes = {
  currencyLabel: PropTypes.string.isRequired,
  periodicCleaning: PropTypes.shape({
    value: PropTypes.string.isRequired,
    additionalInfo: PropTypes.shape({
      fee: PropTypes.number,
      frequency: PropTypes.string.isRequired
    })
  })
};

export default ServicesAndExpenses;
